<template>
  <div class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-fullscreen-md-down modal-dialog-centered">
      <div class="modal-content border-ruderclub-dark-green">
        <div class="modal-header bg-ruderclub-dark-green">
          <h5 class="modal-title">
            <span class="d-flex">
              <span
                class="material-symbols-outlined d-flex align-self-center me-2"
                >settings</span
              >
              <span>Einstellungen</span>
            </span>
          </h5>
          <button
            type="button"
            class="btn-close bg-light"
            @click="$emit('close')"
          ></button>
        </div>
        <div class="modal-body">
          <div class="modal-body">
            <div class="my-2">
              <div class="form-check form-switch">
                <input
                  id="settings-motivierende-nachrichten"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  :checked="motivierendeNachrichten"
                  @input="
                    $emit(
                      'update:motivierendeNachrichten',
                      $event.target.checked
                    )
                  "
                />
                <label
                  for="settings-motivierende-nachrichten"
                  class="form-check-label"
                  >Motivierende Nachrichten:
                  <b>{{ motivierendeNachrichten ? "An" : "Aus" }}</b></label
                >
              </div>
            </div>

            <div class="my-2">
              <div class="form-check form-switch">
                <input
                  id="settings-mode"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  :checked="dynamicSpeed"
                  @input="$emit('update:dynamicSpeed', $event.target.checked)"
                  :disabled="!trainingsmodusMitBluetooth"
                />
                <label for="settings-mode" class="form-check-label"
                  >Geschwindigkeitsmodus:
                  <b>{{ dynamicSpeed ? "dynamisch" : "original" }}</b></label
                >
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="alert alert-info" v-if="dynamicSpeed">
                  <i><b>"Dynamisch"</b></i> bedeutet, dass das Video - im Rahmen
                  der Möglichkeiten, die Youtube liefert - so in etwa in der
                  Geschwindigkeit abgespielt wird, in der Du Dich bewegst.
                </div>
                <div class="alert alert-info" v-if="!dynamicSpeed">
                  <i><b>"Original"</b></i> bedeutet, dass das Video in der
                  Geschwindigkeit abgespielt wird, in der es aufgenommen wurde.
                  <b v-if="!trainingsmodusMitBluetooth"
                    >Ohne Bluetoothverbindung zu Deinem Gerät kann das Video
                    nicht dynamisch abgespielt werden.</b
                  >
                </div>
              </div>
            </div>

            <div v-if="dynamicSpeed">
              <div class="row g-3 align-items-center">
                <div class="col-auto">
                  <label for="settings-base-speed" class="col-form-label"
                    >Geschwindigkeit im Video (ca.):</label
                  >
                </div>
                <div class="col-auto">
                  <div class="input-group">
                    <input
                      id="settings-base-speed"
                      type="number"
                      step="0.1"
                      min="1"
                      max="200"
                      class="form-control"
                      :value="baseSpeedInVideo"
                      @input="
                        $emit('update:baseSpeedInVideo', $event.target.value)
                      "
                    />
                    <span
                      class="input-group-text"
                      id="settings-base-speed-addon"
                      >km/h</span
                    >
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12">
                  <div class="alert alert-info">
                    Der Wert <i><b>"Geschwindigkeit im Video"</b></i> soll
                    annäherungsweise der Durchschnittsgeschwindigkeit
                    entsprechen, die im Video gehalten wird. Falls ich mal
                    komplett daneben lag, sag bitte Bescheid und ich korrigiere
                    die Werte
                  </div>
                </div>
              </div>
            </div>

            <hr />
            <div class="my-2">
              <label for="settings-url" class="form-label">Video-URL</label>
              <input
                id="settings-url"
                type="text"
                class="form-control"
                :value="videoUrl"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-ruderclub-dark-green" @click="$emit('close')">
            <span class="d-flex align-self-center">
              <span class="material-symbols-outlined me-2">check</span>
              Schließen
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: [
    "motivierendeNachrichten",
    "dynamicSpeed",
    "baseSpeedInVideo",
    "videoUrl",
    "trainingsmodusMitBluetooth",
  ],
  emits: [
    "update:motivierendeNachrichten",
    "update:dynamicSpeed",
    "update:baseSpeedInVideo",
  ],
};
</script>

<style></style>
